import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { name: 'Services', href: '#services' },
    { name: 'How It Works', href: '#how-it-works' },
    { name: 'Privacy', href: '#privacy' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <footer className="bg-olive-brown text-white">
      {/* Main Footer Content */}
      <div className="section-padding">
        <div className="container-center">
          <div className="text-center space-y-8">
            {/* Logo */}
            <div className="flex items-center justify-center">
              <img src="/favicon.png" alt="FractionalVA Logo" className="h-12 w-auto" />
            </div>

            {/* Footer Links */}
            <div className="flex justify-center space-x-8">
              {footerLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className="text-white/80 hover:text-burnt-orange transition-colors duration-300"
                  aria-label={`Navigate to ${link.name}`}
                >
                  {link.name}
                </a>
              ))}
            </div>

            {/* Footer Microcopy */}
            <div className="space-y-4">
              <p className="text-white/80">
                FractionalVa provides discreet operational support for busy leaders.
              </p>
              <p className="text-sm text-white/60">
                Availability is limited to maintain quality.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/20 py-6">
        <div className="container-center px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white/70 text-sm">
            © {currentYear} FractionalVa. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;